import { SvgIcon, SvgIconProps } from '@mui/material';

export function ArrowForwardIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Icon" clipPath="url(#clip0_1169_35314)">
          <path
            id="Vector"
            d="M3.75 9.75199H12.1275L8.4675 13.412C8.175 13.7045 8.175 14.1845 8.4675 14.477C8.76 14.7695 9.2325 14.7695 9.525 14.477L14.4675 9.53449C14.76 9.24199 14.76 8.76949 14.4675 8.47699L9.5325 3.52699C9.24 3.23449 8.7675 3.23449 8.475 3.52699C8.1825 3.81949 8.1825 4.29199 8.475 4.58449L12.1275 8.25199H3.75C3.3375 8.25199 3 8.58949 3 9.00199C3 9.41449 3.3375 9.75199 3.75 9.75199Z"
            fill="currentcolor"
          />
        </g>
        <defs>
          <clipPath id="clip0_1169_35314">
            <rect
              width="18"
              height="18"
              fill="white"
              transform="translate(0 0.00195312)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
